const TAG_SUBMISSION_TYPE = 'event';
const TAG_ACTION_CTA = 'click';
const TAG_ACTION_STEP = 'step';
const TAG_ACTION_PAGE_LOAD = 'load';
const TAG_ACTION_DATA = 'data';

let TagManager = {

    tagContainer: null,

    install: function(Vue, options) {
        Vue.prototype.$tracking = this;
        this.init(options.env);
    },

    init: function (env) {
        let promise = new Promise(this.getLoadedGtag);
        if (env === 'production') {
            let tmc = this;
            promise.then(
                function (value) {
                    tmc.tagContainer = value;
                }
            ).catch(() => {
            });
        }
        return this;
    },

    getLoadedGtag: function (resolve) {
        // eslint-disable-next-line
        if (typeof gtag !== "undefined") {
            // eslint-disable-next-line
            resolve(gtag);
        } else {
            setTimeout(function () {
                TagManager.getLoadedGtag(resolve);
            }, 250);
        }
    },

    sendEvent: function (action, details) {
        if (this.tagContainer !== null) {
            this.tagContainer(
                TAG_SUBMISSION_TYPE,
                action,
                details
            );
        }
    },

    logCTA: function (label) {
        this.sendEvent(
            TAG_ACTION_CTA,
            {
                event_category: 'CTA',
                event_label: label,
            }
        )
    },

    logStep: function (category, label) {
        this.sendEvent(
            TAG_ACTION_STEP,
            {
                event_category: category,
                event_label: label,
            }
        )
    },

    logPageLoad: function (label) {
        this.sendEvent(
            TAG_ACTION_PAGE_LOAD,
            {
                event_category: 'Page',
                event_label: label,
            }
        )
    },

    logData: function (category, label, value) {
        this.sendEvent(
            TAG_ACTION_DATA,
            {
                event_category: category,
                event_label: label,
                event_value: value
            }
        )
    }
};

export default TagManager;